var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Text } from '@thinkingmachines/asimov';
import Panel from './Panel';
export const SolidColorBar = (_a) => {
    var { title, min, max, colors = [], description } = _a, props = __rest(_a, ["title", "min", "max", "colors", "description"]);
    return (React.createElement(Panel, Object.assign({}, props),
        title ? React.createElement(Text, { textAlign: 'center' }, title) : null,
        React.createElement(Box, { flexDirection: 'row', border: 'solid 1px black', margin: '0px 5px' }, colors.map((c, i) => (React.createElement(Box, { width: '100%', key: i, height: '10px', backgroundColor: c, paddingBottom: '10px' })))),
        React.createElement(Box, { flexDirection: 'row' },
            React.createElement(Text, { fontSize: '12px' }, min),
            React.createElement(Text, { fontSize: '12px', textAlign: 'right', margin: '0px 0px 0px auto' }, max)),
        description ? (React.createElement(Text, { textAlign: 'justify', fontSize: '14px' }, description)) : null));
};
export const GradientColorBar = (_a) => {
    var { title, min, max, colors = [], description } = _a, props = __rest(_a, ["title", "min", "max", "colors", "description"]);
    return (React.createElement(Panel, Object.assign({}, props),
        title ? React.createElement(Text, { textAlign: 'center' }, title) : null,
        React.createElement(Box, { flexDirection: 'row', border: 'solid 1px black', margin: '0px 5px', paddingBottom: '10px', height: '10px', style: {
                backgroundImage: `linear-gradient(to right, ${colors.join()})`
            } }),
        React.createElement(Box, { flexDirection: 'row' },
            React.createElement(Text, { fontSize: '12px' }, min),
            React.createElement(Text, { fontSize: '12px', textAlign: 'right', margin: '0px 0px 0px auto' }, max)),
        description ? (React.createElement(Text, { textAlign: 'justify', fontSize: '14px' }, description)) : null));
};
export default SolidColorBar;
//# sourceMappingURL=ColorBar.js.map